import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {JsonConfig} from "../models/configuration.model";

@Injectable()
export class ConfigurationDataSource {

    constructor(private http: HttpClient) {
    }

    getConfig(): Observable<JsonConfig> {

        const configUrl = environment.backendApi + 'api/Configuration/GetConfigJson';

        return this.http.get<JsonConfig>(configUrl).pipe(
            //tap(config => console.log("Fetched config:", config)), // Debugging
            catchError(error => {
                console.error('Error loading configuration:', error);
                //  better error handling here.  For example:
                return throwError(() => new Error(`Failed to load configuration: ${error.message || 'Unknown error'}`));
            })
        );
    }
    
}
